export default "https://cdn-static.gokick.com/assets/abc7ffeff8198bd9a29b582a19941a8ba3b1c5b9/images/choco-chill.f91442e53028d067e0a40cd80e4e8aae.png";